export const QUICKSAND = 'Quicksand';

export const LATO = 'Lato';
